<template>
  <div class="pt-1">
  <div v-if="userRole!==rootRoleName">
  <v-btn
    small
    depressed
    id="cutomer-add-btn"
    class="teal lighten-1 white--text"
    @click.native.stop="startDialog"
  >
    <v-icon class="caption">add</v-icon> &nbsp;
        {{$t('customer.add')}}
    </v-btn>
    </div>
    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <v-form
          v-model="validated"
          ref="customerForm">

          <!-- 基本情報 -->
          <v-text-field
            :label="$t('customer.name')"
            v-model="edit.locationName"
            required
            :rules="[v => !!v || $t('account.vali-location-name')]"
          ></v-text-field>

          <v-select
            :label="$t('customer.organization')"
            v-model="edit.organizationId"
            :items="organizations"
            item-text="name"
            item-value="organizationId"
            :rules="[v => !!v || $t('account.vali-org-select')]"
            required
            auto
            :disabled="mode=='EDIT'"
          ></v-select>

          <v-text-field
            :label="$t('customer.tel')"
            :rules="phoneRules"
            v-model="edit.locationPhone"
          ></v-text-field>

          <v-layout>
            <v-flex xs9 class="pa-2" id="locationAddress">
              <v-text-field
                label="Address"
                :label="$t('customer.address')"
                v-model="edit.locationAddress"
              ></v-text-field>
            </v-flex>

            <v-flex xs3 class="pa-2">
              <v-btn block @click="getLatLng" class="primary">
                {{$t('customer.search')}}
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout>

            <v-flex xs4 class="pa-2">
              <v-text-field
                :label="$t('customer.latitude')"
                v-model="edit.latitude"
              ></v-text-field>
            </v-flex>

            <v-flex xs4 class="pa-2">
              <v-text-field
                :label="$t('customer.longitude')"
                v-model="edit.longitude"
              ></v-text-field>
            </v-flex>

            <v-flex xs4 class="pt-4">
              <v-btn small @click="showMap=!showMap" :class="showMap?'':''">
                  <span v-if="showMap==false"><v-icon>expand_more</v-icon> {{$t('customer.open-map')}}</span>
                  <span v-if="showMap==true"><v-icon>expand_less</v-icon> {{$t('customer.close-map')}}</span>
              </v-btn>
              <!-- <v-btn small @click="showMap=!showMap" :class="showMap?'red lighten-4':''">
                  <v-icon v-if="showMap==false">place</v-icon>
                  <span v-if="showMap==true">close</span>
              </v-btn> -->
            </v-flex>
          </v-layout>
          <div>
            <map-modal v-if="showMap" :edit="edit" @selectLocation="selectLocation" ref="mapmodal"></map-modal>
          </div>
          <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click.native="showDialog=false"
              >
                {{$t('account.cancel')}}
              </v-btn>

              <v-btn
                v-if="mode=='ADD'"
                color="primary"
                class="ml-4"
                @click.prevent="registLocation"
                :disabled="btnDisable||!validated"
              >
                {{$t('btn.save')}}
              </v-btn>
              <v-btn
                v-if="mode=='EDIT'"
                color="primary"
                class="ml-4"
                @click.prevent="updateLocation"
                :disabled="btnDisable||!validated"
              >
                {{$t('btn.save')}}
              </v-btn>
          </v-layout>
          <!-- errors -->
          <div v-if="errorMessage" class="red--text">
            <strong>{{errorMessage}}</strong>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'
import MapModal from '@/components/MapModal.vue'

export default {
  components: {
    MapModal
  },
  data () {
    return {
      mode: 'ADD', // or EDIT （顧客追加か顧客編集か）
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      edit: {},
      validated: false,
      organizations: [],
      errorMessage: '',
      showDialog: false,
      showMap: false,
      btnDisable: false,
      phoneRules: [
        v => validate.phoneFormat(v) ||
        this.$t('validate.phone-format'),
        v => v.length <= 128 || this.$t('validate.phone-length')
      ]
    }
  },
  methods: {
    init () {
      this.mode = 'ADD'
      this.getOrganizations()
    },
    getOrganizations () {
      http.request('get', '/service2/dashboard/api/Organizations/organizationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization data failed. (' + data.result + ')')
            return
          }
          this.organizations = data.organizations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    startDialog (edit) {
      this.$refs.customerForm.reset() // 一旦バリデーション等をリセット
      if (edit.locationId != null) {
        // 引数あれば編集モード
        this.mode = 'EDIT'
        // 参照渡しにならないように各々代入 TODO:少しやり方が汚い
        this.edit.organizationId = edit.organizationId
        this.edit.locationName = edit.locationName
        this.edit.locationId = edit.locationId
        this.edit.locationAddress = edit.locationAddress
        this.edit.locationPhone = edit.locationPhone
        this.edit.latitude = edit.latitude
        this.edit.longitude = edit.longitude
      } else {
        // 引数なければ追加モード
        this.mode = 'ADD'
        this.edit.organizationId = ''
        this.edit.locationName = ''
        this.edit.locationAddress = ''
        this.edit.locationPhone = ''
        this.edit.latitude = ''
        this.edit.longitude = ''
      }
      // null値が入っていると、バリデーションが効かない
      for (let k in this.edit) {
        if (this.edit[k] == null) this.edit[k] = ''
      }
      this.errorMessage = ''
      this.showMap = false
      this.btnDisable = false
      this.showDialog = true
    },
    registLocation () {
      this.btnDisable = true // ボタン無効化
      const params = {
        organizationId: this.edit.organizationId,
        name: this.edit.locationName,
        address: this.edit.locationAddress,
        phone: this.edit.locationPhone,
        latitude: this.edit.latitude,
        longitude: this.edit.longitude
      }
      http.request('post', '/service2/dashboard/api/Locations/register', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('regist location data failed. (' + data.result + ')')
            this.showError(data.result)
            this.btnDisable = false
            return
          }
          this.$emit('child-action', 'success', 'success!')
          this.showDialog = false
        })
        .catch(error => {
          console.log('error', error)
          this.showError(error)
          this.btnDisable = false
        })
    },
    updateLocation () {
      this.submitted = true // ボタン無効化
      const params = {
        locationId: this.edit.locationId,
        organizationId: this.edit.organizationId,
        name: this.edit.locationName,
        address: this.edit.locationAddress,
        phone: this.edit.locationPhone,
        latitude: this.edit.latitude,
        longitude: this.edit.longitude
      }
      http.request('post', '/service2/dashboard/api/Locations/edit', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('update location data failed. (' + data.result + ')')
            this.showError(data.result)
            this.btnDisable = false
            return
          }
          this.$emit('child-action', 'success', 'success!')
          this.showDialog = false
        })
        .catch(error => {
          console.log('error', error)
          this.showError(error)
          this.btnDisable = false
        })
    },
    getLatLng () {
      const self = this
      /* global google */
      let la, dv
      la = document.getElementById('locationAddress')
      dv = la.getElementsByTagName('div')
      var geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': this.edit.locationAddress}, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          self.edit.latitude = results[0].geometry.location.lat()
          self.edit.longitude = results[0].geometry.location.lng()
          for (let i = 0; i < dv.length; i++) {
            if (dv[i].classList.contains('input-group__details')) {
              dv[i].innerHTML = ''
            }
          }
          // MapModalの地図を更新
          if (self.showMap) {
            self.$refs.mapmodal.initMap()
          }
        } else {
          for (let i = 0; i < dv.length; i++) {
            if (dv[i].classList.contains('input-group__details')) {
              dv[i].innerHTML = self.$t('customer.error-location')
            }
            self.edit.latitude = ''
            self.edit.longitude = ''
          }
          console.log('Geocode was not successful for the following reason: ' + status)
        }
      })
    },
    showError (error) {
      this.errorMessage = 'failed. (' + error + ')'
    },
    selectLocation () {
      console.log('selectLocation')
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

#maps {
  -webkit-transition: width 300ms ease, height 300ms ease;
  transition: width 300ms ease, height 300ms ease;
}

#customer-add-btn {
  border-radius: 0px;
}

 </style>



// WEBPACK FOOTER //
// CustomerEdit.vue?19595fbf